import { FieldPropertyMention } from '../../FieldPropertyMention'
import { FormInputProps } from '../types'

export function TemplateFormInput (props: FormInputProps) {
  return (
    <FieldPropertyMention
      value={props.value?.type === 'template' ? props.value.template : undefined}
      onChange={value => props.onChange({ type: 'template', template: value })}
      fields={props.fields ?? []}
    />
  )
}
